/**
 * @generated SignedSource<<25029eaacbac796d67449a75f11dcbe0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PresentationSimilar_presentation$data = {
  readonly similarPresentations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"PresentationCardNew_presentation">;
      };
    }>;
  };
  readonly " $fragmentType": "PresentationSimilar_presentation";
};
export type PresentationSimilar_presentation$key = {
  readonly " $data"?: PresentationSimilar_presentation$data;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationSimilar_presentation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationSimilar_presentation",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 4
        }
      ],
      "concreteType": "PresentationsConnection",
      "kind": "LinkedField",
      "name": "similarPresentations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PresentationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Presentation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PresentationCardNew_presentation"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "similarPresentations(first:4)"
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};

(node as any).hash = "9838692c82ecc4fccdc22b1c9177b20f";

export default node;
